import {
  DATA_LAYER_EVENTS,
  DataLayerEvent,
  SmdlAssets,
  SmdlModule,
} from '@smarty-nx/tracking'

import {
  addTrackEvent,
  findAssets,
  findModules,
  findOrderType,
  moduleEvent,
} from '../static/scripts/dmpg'

/**
 *  Triggers dmpg event and builds product with id.
 * Also takes an optional checkout opton for cart events
 * */
export const triggerProductEvent = (
  event: string,
  product: { id: string; name: string; category: string } & Record<
    string,
    unknown
  >,
  checkoutType: string,
  orderType?: string
) => {
  addTrackEvent(
    {
      event,
      checkoutType,
      ...(orderType ? { order_type: orderType } : {}),
      product,
    },
    { extras: true }
  )
}

export const triggerModuleLoadEvent = (
  parentElement: Document,
  slug: string,
  moduleId: string
) => {
  const output = moduleEvent(parentElement, slug, moduleId)
  addTrackEvent(output)
}

export const triggerCustomModuleLoadEvent = (
  modules: SmdlModule[],
  assets?: SmdlAssets
) => {
  const output: DataLayerEvent = {
    event: DATA_LAYER_EVENTS.MODULE_LOAD,
    modules,
  }

  if (assets) {
    output.assets = assets
  }

  addTrackEvent(output)
}

export const triggerModuleClickEvent = (
  id: string,
  type: string,
  moduleId: string,
  eventParams: Record<string, string> = {}
) => {
  addTrackEvent({
    event: DATA_LAYER_EVENTS.MODULE_CLICK,
    ...eventParams,
    moduleItem: {
      id: id,
      type: type,
      moduleId: moduleId,
    },
  })
}

export const triggerProductViewEvent = (
  product: { id: string; name: string; category: string } & Record<
    string,
    unknown
  >
) => {
  addTrackEvent({
    event: DATA_LAYER_EVENTS.PRODUCT_VIEW,
    product,
  })
}

export const triggerModuleLoadEvent2 = (
  moduleId: string,
  moduleOrderType?: string,
  event = DATA_LAYER_EVENTS.MODULE_LOAD
) => {
  const moduleRoot = document.querySelector(
    `[data-module-id="${moduleId}"]`
  ) as HTMLElement

  const orderType = moduleOrderType ?? findOrderType(moduleRoot)

  addTrackEvent({
    event,
    modules: findModules(moduleId),
    assets: findAssets(moduleRoot),
    ...(orderType ? { order_type: orderType } : {}),
  })
}
